<template>
    <div>
        <label v-if="label" class="form-label">{{ label }}:</label>
        <div class="form-input">
            <input ref="file" type="file" :accept="accept" class="hidden" v-bind="$attrs" @change="change"/>
            <div v-if="this.files.length < this.maxFilesAllowed" class="mb-2 mt-3">
                <button type="button" class="btn btn-warning btn-block" @click="browse">
                    <i class="fa fa-file"></i> Select File
                </button>
            </div>
            <div class="mb-3">
                <div v-for="(file, index) in files" :key="file.name">
                    {{file.name}} <span class="text-gray-500 text-xs">({{ filesize(file.size) }})</span>
                    <button type="button" class="btn-sm btn btn-block btn-danger delete-btn" @click="removeAFile(index)">
                        x
                    </button>
                </div>
            </div>
        </div>
        <div v-if="error" class="help-block with-errors">{{ error }}</div>
    </div>
</template>

<script>
export default {
    props: {
        value: [],
        label: String,
        accept: String,
        error: String,
    },
    data: function ()  {
        return {
            maxFilesAllowed: 3,
            files: []
        }
    },
    methods: {
        filesize(size) {
            let i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        browse() {
            this.$refs.file.click()
        },
        addAFile(file) {
            if(this.files.length >= this.maxFilesAllowed){
                return
            }

            let hasFile = this.files.find( uploadeFile => uploadeFile['name'] === file.name );

            if(hasFile) {
                this.error = 'The same file has already been uploaded'
                return
            }

            this.files.push(file)
            this.$emit('input', this.files)
        },
        removeAFile(index) {
            this.$delete(this.files, index)  
            
            if(!this.files || this.files.length === 0){
                this.$emit('input', null)
            }    
        },
        change(e) {
            let fileSizeLimit = e.target.getAttribute('size-mb')
            if (e.target.files[0].size > fileSizeLimit*1024*1000) {
                this.error = e.target.getAttribute('error-msg')
                return
            }

            this.addAFile(e.target.files[0])
        },
    },
}
</script>
